/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Title, TextInput } from 'ui-library';
import { isQRIban } from 'utils';

import { validateIban } from 'utils/validation';

const ChangeWithdrawalPlanBankInfo = ({ datasource }: {datasource: any}) => {
    const {
        data,
        control,
        trigger,
        errorData,
        setErrorData,
    } = datasource({});

    const { t } = useTranslation();

    return (
        <div>
            <Title type={3} style={{ marginBottom: 32, marginTop: -20, lineHeight: '30px' }}>
                {t('3b.withdrawalPlan.ChangeWithdrawalBankInfo.subtitle')}
            </Title>
            <div className="form">
                <Controller
                    name="iban"
                    control={control}
                    render={({ field: { onChange, ...field } }) => (
                        <TextInput
                            {...field}
                            data-cy="iban"
                            label={t('3b.withdrawalPlan.bankIban')}
                            value={data?.iban}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                onChange(e.target.value);
                                setErrorData('iban', { message: '' });
                            }}
                            error={errorData?.iban?.message}
                            onBlur={async (e: React.ChangeEvent<HTMLInputElement>) => {
                                setErrorData('iban', {
                                    message: await validateIban(e?.target?.value) as string,
                                });
                            }}
                            required
                        />
                    )}
                />

                <Controller
                    name="esr"
                    control={control}
                    render={({ field: { onChange, ...field } }) => (
                        <TextInput
                            {...field}
                            data-cy="esr"
                            label={t('3b.withdrawalPlan.esr')}
                            value={data?.esr}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                onChange(e.target.value);
                                setErrorData('esr', { message: '' });
                            }}
                            error={errorData?.esr?.message}
                            required={isQRIban(data?.iban)}
                            labelInfo={t('3b.withdrawalPlan.esr.info')}
                        />
                    )}
                />

                <Controller
                    name="firstName"
                    control={control}
                    render={({ field }) => (
                        <TextInput
                            {...field}
                            value={data?.firstName}
                            data-cy="firstName"
                            label={t('clientDetails.firstName')}
                            error={errorData?.firstName?.message}
                            required
                        />
                    )}
                />

                <Controller
                    name="lastName"
                    control={control}
                    render={({ field }) => (
                        <TextInput
                            {...field}
                            data-cy="lastName"
                            value={data?.lastName}
                            label={t('clientDetails.lastName')}
                            error={errorData?.lastName?.message}
                            required
                        />
                    )}
                />

                <Controller
                    name="bankName"
                    control={control}
                    render={({ field }) => (
                        <TextInput
                            {...field}
                            data-cy="bankName"
                            value={data?.bankName}
                            label={t('3b.withdrawalPlan.bankName')}
                            error={errorData?.bankName?.message}
                            required
                        />
                    )}
                />

                <div className="change-withdrawal-options-bankZip">
                    <div className="form-group">
                        <label className="Form-control-label">{`${t('3b.withdrawalPlan.bankZipCode')}/${t('3b.withdrawalPlan.bankCity')} *`}</label>
                        <div className="change-withdrawal-options-bankZip-inputs">
                            <Controller
                                name="zipCode"
                                control={control}
                                render={({ field: { onChange, ...field } }) => (
                                    <TextInput
                                        {...field}
                                        value={data?.zipCode}
                                        data-cy="zipCode"
                                        error={errorData?.zipCode?.message}
                                        onChange={(value: number) => {
                                            onChange(value);
                                            trigger('zipCode');
                                        }}
                                        required
                                    />
                                )}
                            />
                            <Controller
                                name="city"
                                control={control}
                                render={({ field }) => (
                                    <TextInput
                                        {...field}
                                        value={data?.city}
                                        data-cy="city"
                                        error={errorData?.city?.message}
                                        required
                                    />
                                )}
                            />
                        </div>
                    </div>

                </div>
            </div>
        </div>

    );
};

export default ChangeWithdrawalPlanBankInfo;
